module.exports = __webpack_public_path__ + "img/title1.8c8254f3.png";